<div class="modal fade" tabindex="-1" role="dialog" id="regional-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Definir filtros</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container striped-rows">
          <div class="row ptb5">
            <div class="col col-4">
              Usuário
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text" placeholder="Informe o Usuário..." [(ngModel)]="filtros.id_usuario">
            </div>
          </div>
          <div class="row ptb5">
            <div class="col col-4">
              Região
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text" placeholder="Informe a Região..." [(ngModel)]="filtros.id_regiao">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="filtros.id_usuario = '' || filtros.id_regiao = ''">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>